import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const RelationshipViewSettingsRecord = Record({
  showIdentifier: false,
  showDates: true,
  showDuration: false,
  showNarrative: false,
  showSummary: false,
  showInfoIcons: false,
  showEntityColor: false
});

createFromJS.registerCallback(
  "RelationshipViewSettingsRecord",
  createFromJS.createPrimitiveCallback(RelationshipViewSettingsRecord)
);
